<template>
     <component 
      :is="tag"
      @click="prevent ? setDefault($event) : '', $emit('click')"
      class="button"
      :id="id"
      :type="type"
      :href="href"
      :to="to"
      :class="classes"
      :disabled="disabled"
    >{{ title }}
    </component>
</template>

<script>

export default {
  name: 'Button',
  data: () => ({
  }),
  components: {
  },
  computed: {
  },
  props: {
    to: { type: String , required: false, default: null },
    tag: { type: String , required: false, default: 'button' },
    type: { type: String , required: false, default: null },
    id: { type: String , required: false, default: null },
    title: { type: String , required: false, default: '' },
    prevent: { type: Boolean , required: false, default: false },
    href: { type: String , required: false, default: null },
    disabled: { type: Boolean, required: false, default: null },
    classes: { type: String, required: false, default: '' }
  },
  mounted () {
  },
  created () {
  },
  methods: {
    setDefault (e) {
      e.preventDefault()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "../../scss/global/includes";

.button {
    background: $primary;
    border-radius: 2px;
    font-family: $font-bold;
    font-size: 16px;
    color: #FFFFFF;
    text-align: center;
    padding: 14px 30px;
    display: block;
    outline: none;
    border: 0px;
    width: 100%;

    &:disabled {
      background: $mid-light;
      cursor: default;
    }

    &.button--google {
      background: transparent;
      border: 1px solid $primary;
      font-family: inherit;
      color: $strong-light;
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;

      &:before {
        content: "";
        background: url(/assets/icon-google.svg);
        background-repeat: no-repeat;
        background-position: center center;
        width: 25px;
        height: 25px;
        margin-right: 15px;
      }
    }
}

</style>
